import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "m16 2-2.3 2.3a3 3 0 0 0 0 4.2l1.8 1.8a3 3 0 0 0 4.2 0L22 8",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M15 15 3.3 3.3a4.2 4.2 0 0 0 0 6l7.3 7.3c.7.7 2 .7 2.8 0L15 15Zm0 0 7 7",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Path, { d: "m2.1 21.8 6.4-6.3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m19 5-7 7", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "UtensilsCrossed";
const UtensilsCrossed = memo(themed(Icon));
export {
  UtensilsCrossed
};
//# sourceMappingURL=utensils-crossed.js.map
